import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

const environment = 'snitch'

export default {
  namespaced: true,
  state: {
    serviceUnavailable: false,
    serviceRequested: false,
    fetchingHealthchecks: true,
    healthchecksResultInfo: {},
    resultInfo: {},
    currentPage: 1,
    healthchecks: [],
    healthcheck: {},
    gettingHealthcheck: true,
    addingHealthcheck: false,
    updatingHealthcheck: false,
    removingHealthcheck: false,
    healthcheckGroups: [],
    fetchingHealthcheckGroups: false,
    gettingHealthcheckGroup: false,
    healthcheckGroup: {},
    addingHealthcheckGroup: false,
    updatingHealthcheckGroup: false,
    removingHealthcheckGroup: false,
    healthcheckGroupsResultInfo: {},
    groupsCurrentPage: 1,
    groupId: null,
    selectedGroup: 0,
    datacenter: {},
    datacenters: [],
    gettingDatacenter: false,
    fetchingDatacenters: false,
  },
  getters: {
    currentPage: state => state.currentPage,
    groupsCurrentPage: state => state.groupsCurrentPage,
    groupId: state => state.groupId,
  },
  mutations: {
    SET_SERVICE_UNAVAILABLE(state, value) {
      state.serviceUnavailable = true
      state.serviceRequested = value
    },
    SET_FETCHING_HEALTHCHECKS(state, value) {
      state.fetchingHealthchecks = value
    },
    SET_HEALTHCHECKS(state, value) {
      state.healthchecks = value.result
      state.healthchecksResultInfo = value.resultInfo
    },
    GET_HEALTHCHECK(state, value) {
      state.healthcheck = value
    },
    REMOVE_HEALTHCHECK(state, id) {
      state.healthchecks = state.healthchecks.filter(h => h.id !== id)
    },
    SET_ADDING_HEALTHCHECK(state, value) {
      state.addingHealthcheck = value
    },
    SET_UPDATING_HEALTHCHECK(state, value) {
      state.updatingHealthcheck = value
    },
    SET_REMOVING_HEALTHCHECK(state, value) {
      state.removingHealthcheck = value
    },
    SET_GETTING_HEALTHCHECK(state, value) {
      state.gettingHealthcheck = value
    },
    SET_CURRENT_PAGE(state, value) {
      state.currentPage = value
    },
    SET_FETCHING_HEALTHCHECK_GROUPS(state, value) {
      state.fetchingHealthcheckGroups = value
    },
    SET_HEALTHCHECK_GROUPS(state, value) {
      state.healthcheckGroups = value.result
      state.healthcheckGroupsResultInfo = value.resultInfo
    },
    GET_HEALTHCHECK_GROUP(state, value) {
      state.healthcheckGroup = value
    },
    SET_ADDING_HEALTHCHECK_GROUP(state, value) {
      state.addingHealthcheckGroup = value
    },
    SET_UPDATING_HEALTHCHECK_GROUP(state, value) {
      state.updatingHealthcheckGroup = value
    },
    SET_REMOVING_HEALTHCHECK_GROUP(state, value) {
      state.removingHealthcheckGroup = value
    },
    SET_GETTING_HEALTHCHECK_GROUP(state, value) {
      state.gettingHealthcheckGroup = value
    },
    SET_GROUPS_CURRENT_PAGE(state, value) {
      state.groupsCurrentPage = value
    },
    UPDATE_HEALTHCHECK_GROUP(state, value) {
      const elementPos = state.healthcheckGroups.map(x => x.id).indexOf(value.id)
      state.healthcheckGroups[elementPos].name = value.name
      state.healthcheckGroups[elementPos].description = value.description
      state.healthcheckGroups[elementPos].isDefault = value.isDefault
    },
    SET_GROUP_ID(state, value) {
      state.groupId = value
    },
    SET_FAVORITE_GROUP(state, id) {
      const element = state.healthcheckGroups.find(el => el.isDefault)
      if (element) element.isDefault = false
      state.healthcheckGroups.find(el => el.id === id).isDefault = element?.id !== id
    },
    SET_SELECTED_GROUP(state, id) {
      state.selectedGroup = id
    },
    SET_FETCHING_DATACENTERS(state, value) {
      state.fetchingDatacenters = value
    },
    SET_GETTING_DATACENTER(state, value) {
      state.gettingDatacenter = value
    },
    SET_DATACENTERS(state, value) {
      state.datacenters = value.result
    },
    GET_DATACENTER(state, value) {
      state.datacenter = value
    },
  },
  actions: {
    fetchHealthchecks({ commit }, query) {
      commit('SET_FETCHING_HEALTHCHECKS', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/healthchecks?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}&GroupId=${query.groupId}`)
          .then(response => {
            commit('SET_HEALTHCHECKS', response.data)
            resolve(response)
          })
          .catch(error => {
            if (error.response?.status === 426 || error.response?.status === 428) {
              commit('SET_SERVICE_UNAVAILABLE', error.response?.status === 428)
            }
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_HEALTHCHECKS', false) })
      })
    },
    addHealthcheck({ commit }, query) {
      commit('SET_ADDING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api(environment).post(`/projects/${getProjectId()}/healthchecks`, query.healthcheck)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_HEALTHCHECK', false) })
      })
    },
    toggleHealthcheck({ commit }, query) {
      commit('SET_UPDATING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api(environment).patch(`/projects/${getProjectId()}/healthchecks/${query.id}/toggle`, { state: query.state })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_HEALTHCHECK', false) })
      })
    },
    updateHealthcheck({ commit }, query) {
      commit('SET_UPDATING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api(environment).put(`/projects/${getProjectId()}/healthchecks/${query.id}`, query.healthcheck)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_HEALTHCHECK', false) })
      })
    },
    removeHealthcheck({ commit }, id) {
      commit('SET_REMOVING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api(environment).delete(`/projects/${getProjectId()}/healthchecks/${id}`)
          .then(response => {
            commit('REMOVE_HEALTHCHECK', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_HEALTHCHECK', false) })
      })
    },
    getHealthcheck({ commit }, id) {
      commit('SET_GETTING_HEALTHCHECK', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/healthchecks/${id}`)
          .then(response => {
            commit('GET_HEALTHCHECK', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_HEALTHCHECK', false) })
      })
    },
    fetchHealthcheckGroups({ commit }, query) {
      commit('SET_FETCHING_HEALTHCHECK_GROUPS', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/healthcheck-groups?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`)
          .then(response => {
            commit('SET_HEALTHCHECK_GROUPS', response.data)
            resolve(response)
          })
          .catch(error => {
            if (error.response?.status === 426 || error.response?.status === 428) {
              commit('SET_SERVICE_UNAVAILABLE', error.response?.status === 428)
            }
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_HEALTHCHECK_GROUPS', false) })
      })
    },
    getHealthcheckGroup({ commit }, id) {
      commit('SET_GETTING_HEALTHCHECK_GROUP', true)
      return new Promise((resolve, reject) => {
        api(environment).get(`projects/${getProjectId()}/healthcheck-groups/${id}`)
          .then(response => {
            commit('GET_HEALTHCHECK_GROUP', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_HEALTHCHECK_GROUP', false) })
      })
    },
    addHealthcheckGroup({ commit }, group) {
      commit('SET_ADDING_HEALTHCHECK_GROUP', true)
      return new Promise((resolve, reject) => {
        api(environment).post(`/projects/${getProjectId()}/healthcheck-groups`, group)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_HEALTHCHECK_GROUP', false) })
      })
    },
    updateHealthcheckGroup({ commit }, query) {
      commit('SET_UPDATING_HEALTHCHECK_GROUP', true)
      return new Promise((resolve, reject) => {
        api(environment).put(`/projects/${getProjectId()}/healthcheck-groups/${query.id}`, query.group)
          .then(response => {
            commit('UPDATE_HEALTHCHECK_GROUP', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_HEALTHCHECK_GROUP', false) })
      })
    },
    removeHealthcheckGroup({ commit }, { id, deleteHealthchecks }) {
      commit('SET_REMOVING_HEALTHCHECK_GROUP', true)
      return new Promise((resolve, reject) => {
        api(environment).delete(`/projects/${getProjectId()}/healthcheck-groups/${id}?deleteHealthchecks=${deleteHealthchecks}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_HEALTHCHECK_GROUP', false) })
      })
    },
    fetchDatacenters({ commit }) {
      commit('SET_FETCHING_DATACENTERS', true)
      return new Promise((resolve, reject) => {
        api('snitch').get(`projects/${getProjectId()}/data-centers`)
          .then(response => {
            commit('SET_DATACENTERS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_DATACENTERS', false) })
      })
    },
    getDatacenter({ commit }, id) {
      commit('SET_GETTING_DATACENTER', true)
      return new Promise((resolve, reject) => {
        api('snitch').get(`projects/${getProjectId()}/data-centers/${id}`)
          .then(response => {
            commit('GET_DATACENTER', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_DATACENTER', false) })
      })
    },
  },
}
